import { LabeledData } from '@gorila-shared-ui/components';
import { StyledDivider } from 'baseui/divider';
import { useDevice } from '../../../hooks/useDevices';
import { useStyles } from '../../../hooks/useStyles';
import { MinimalDevice } from '../../../types/device';
import LabeledDataCard from '../labeledDataCard/LabeledDataCard';

type Props = Readonly<{
  model: string;
  device: MinimalDevice;
}>;

function CurrentStateDevice({ model, device }: Props) {
  const { overrides } = useStyles();
  const { getDeviceCarrierLabel } = useDevice();
  const labelWidth = '50px';

  return (
    <LabeledDataCard
      label="Dispositivo"
      rootStyleOverrides={{
        flexGrow: 2,
        flexShrink: 1,
        flexBasis: 0,
      }}
    >
      <LabeledData
        label="Modelo:"
        content={model}
        labelWidth={labelWidth}
        inline={false}
        maxLines={3}
      />
      <StyledDivider style={overrides.dividerStyleOverrides} />
      <LabeledData
        label="SIM:"
        content={device.sim || '-'}
        labelWidth={labelWidth}
        inline={false}
        maxLines={3}
      />
      <StyledDivider style={overrides.dividerStyleOverrides} />
      <LabeledData
        label="Carrier:"
        content={device.carrier ? getDeviceCarrierLabel(device.carrier) : '-'}
        labelWidth={labelWidth}
        inline={false}
        maxLines={3}
      />
    </LabeledDataCard>
  );
}

export default CurrentStateDevice;
